<template>
  <el-dialog title="Alterar Taxa de Adm." :visible.sync="visibility" @open="iniciar" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="350px">
    <el-form ref="form" :model="aluguelRecuperado" :rules="validacao" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Aluguel">
            <el-input v-model="aluguelRecuperado.idNaImobiliaria" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Comissão">
              <el-input
                v-model="percentualReajuste "
                @keypress.native="validarInputNumerico"
                @keyup.native="validarSeparadorDecimal"
              >
                <template slot="append">
                  %
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        <el-col :span="12">
          <el-form-item label="Mês série" prop="primeiroMesSerie">
            <el-input v-model="aluguelRecuperado.primeiroMesSerie" v-mask="'###'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-checkbox v-model="aluguelRecuperado.somenteMesSerieSelecionado" label="Somente para o mês selecionado"></el-checkbox>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="false">
        <el-col :span="24">
          <el-form-item>
            <el-checkbox v-model="aluguelRecuperado.taxaAdministracaoComplementar" label="Taxa de administração extra"></el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="false">
        <el-col :span="24">
          <el-form-item style="text-align: center;">
              <strong>{{ 'Última taxa de administração extra' }}</strong><br/>
              <strong>{{ this.labelUltimaTaxaAdministracaoComplementar }}</strong>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="alterarTaxaAdministracaoHandler" type="primary" size="small" round class="btn-box-shadow">Alterar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    aluguel: Object,
    visibility: Boolean
  },

  components: {
  },

  data() {
    return {
      aluguelRecuperado: {},
      labelUltimaTaxaAdministracaoComplementar: '',

      validacao: {
        comissao: [{ required: true }, {type: 'number', max: 100}],
        primeiroMesSerie: [{ required: true }]
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false,
        min: 0.0,
        max: 100
      },

      percentualComissaoIsSelecionado: true,

      novoValor: 0,
      percentualReajuste: 0,
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisContratosStore', [
      'ultimaTaxaAdministracaoComplementar',
      'alterarTaxaAdministracaoAluguel'
    ]),
    iniciar() {
      this.aluguelRecuperado = {
        id: this.aluguel.id,
        imovel: this.aluguel.imovel,
        idNaImobiliaria: this.aluguel.idNaImobiliaria,
        somenteMesSerieSelecionado: false,
        taxaAdministracaoComplementar: false,
        valor: this.aluguel.valor
      }
      this.recuperarUltimaTaxaAdministracaoComplementarHandler()
    },
    recuperarUltimaTaxaAdministracaoComplementarHandler(){
      let payload = { id: this.aluguelRecuperado.imovel.id }

      this.showLoading();
      this.ultimaTaxaAdministracaoComplementar(payload)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
         case "SUCESSO":
            this.labelUltimaTaxaAdministracaoComplementar = resultado.item.dataVencimento + " (" + resultado.item.aluguel.idNaImobiliaria + ") "
           break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    alterarTaxaAdministracaoHandler(){
      this.aluguelRecuperado.comissao = this.percentualReajuste;
      this.$refs['form'].validate((valid) => {
        if(valid){
          this.showLoading();
          this.alterarTaxaAdministracaoAluguel(this.aluguelRecuperado)
          .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                break;
              default:
                this.$message.warning(resultado.mensagem);
                break;
            }
            this.fechar();
          }).catch(() => {
            this.fechar();
            this.hideLoading();
          });
        }
      });
    },
    fechar() {
      this.$emit('close');
      this.reset();
    },

    reset() {
      this.percentualComissaoIsSelecionado = true;

      this.novoValor = 0;
      this.percentualReajuste = 0;
    },

    validarInputNumerico(event) {
      const valorDigitado = event.key;
      const valoresPermitidos = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','];
      const valorNaoEhPermitido = !valoresPermitidos.includes(valorDigitado);

      if(valorNaoEhPermitido) event.preventDefault();
    },

    validarSeparadorDecimal(event) {
      const textoDigitado = event.target.value;
      
      const textoComVirgulasTratadas = this.substituirTodaVirgulaPorPonto(textoDigitado);
      const textoComPontosTratados = this.removerTodosOsPontosDepoisDoPrimeiro(textoComVirgulasTratadas);

      const textoFinal = textoComPontosTratados;

      event.target.value = textoFinal;
    },

    substituirTodaVirgulaPorPonto(texto) {
      return texto.replace(/,/g, '.');
    },
    removerTodosOsPontosDepoisDoPrimeiro(texto) {
      return texto.replace(/(?<=\..*)\./g, '');
    },
  }
}
</script>
